import { USER_ROLES } from '@/mappings/user-roles';

/**
 * Ограничивающие роли и закрытые для них маршруты.
 *
 * ROLE_NEW_AFFILIATE_MANAGER выдаётся вместе с ROLE_AFFILIATE_MANAGER, поэтому
 * разрешающего meta.roles маршрута недостаточно: по более широкой роли раздел
 * всё равно попадёт в навбар и откроется по прямой ссылке. Такие маршруты
 * перечисляем здесь: checkRole скрывает по ним пункт навигации, router guard
 * отправляет прямой переход на /404.
 */
export const DENIED_ROUTES_BY_ROLE: Partial<Record<USER_ROLES, readonly string[]>> = {
    [USER_ROLES.NEW_AFFILIATE_MANAGER]: [
        // Регистрации
        'registrations',
        'registration',
        // События
        'postback-errors',
        'postback-error-chart',
        // Статистика по брокерам
        'broker-pair',
        // Акции
        'top-of-campaigns',
        'cashback-ecom',
        'cashback-ecom-detail',
        // Опросы
        'surveys',
        'survey',
        'create-survey',
    ],
};

export const isRouteDeniedForRoles = (
    routeName?: string | null,
    userRoles?: string[] | null,
): boolean => {
    // roles приходят из persisted-стора: там может лежать что угодно, вплоть до не массива
    if (!routeName || !Array.isArray(userRoles)) return false;

    return userRoles.some((role) => DENIED_ROUTES_BY_ROLE[role as USER_ROLES]?.includes(routeName));
};
